export const MODIFY_EDIT_OPTIONS = 'MODIFY_EDIT_OPTIONS';

export function modifyEditOptions(editOptions){
    return{
        type: MODIFY_EDIT_OPTIONS,
        mainState: {
            editOptions: editOptions
        }
    }
}